import '../styles/main.scss';
import './main-common.js';
